export default __webpack_public_path__ + "media/zurb/img/case-study-libdib/libdib-img1-f8a57a1ccdb1e332e1bf40bdfafc1e46.jpg";